import React, { forwardRef, RefObject, useEffect, useImperativeHandle, useRef } from 'react';
import { MessageBanner, MessageBannerType } from '@amzn/stencil-react-components/message-banner';

interface CreateRiskBannerProps {
  type: MessageBannerType;
  onDismissed?: () => void;
  autoDismissAfter?: number;
  ariaLive?: 'polite' | 'assertive' | 'off';
  ref?: RefObject<HTMLDivElement>;
  children: React.ReactNode;
}

const FocusedMessageBanner = forwardRef(
  ({ type, onDismissed, children, autoDismissAfter, ariaLive = 'assertive' }: CreateRiskBannerProps, ref) => {
    const localMessageBannerRef = useRef<HTMLDivElement>(null);
    useImperativeHandle(ref, () => localMessageBannerRef.current);

    useEffect(() => {
      if (localMessageBannerRef.current) {
        localMessageBannerRef.current.focus();
      }
    }, []);

    return (
      <MessageBanner
        aria-live={ariaLive}
        isDismissible={true}
        type={type}
        ref={localMessageBannerRef}
        onDismissed={onDismissed}
        autoDismissAfter={autoDismissAfter}
      >
        {children}
      </MessageBanner>
    );
  },
);

export default FocusedMessageBanner;
